import { setLegalAgreement, setLegalModal } from '../../../../store/signUp/slice';
import LegalContainer from '../../../../containers/Legal';
import { useDispatch } from '../../../../store/store';
import Modal from '../../../../components/Modal';

export default function Legal() {
    const dispatch = useDispatch();

    const agree = () => {
        dispatch(setLegalAgreement(true));
        dispatch(setLegalModal(false));
    };

    return (
        <Modal
            size='xxl'
            title='Legal'
            closeFunc={() => dispatch(setLegalModal(false))}
            actions='both'
            restrictActionsWidth
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: () => dispatch(setLegalModal(false)),
            }}
            confirmButton={{
                text: 'Agree',
                type: 'Primary',
                onClick: agree,
            }}
        >
            <LegalContainer />
        </Modal>
    )
}
